function vzCommentboxGrowInit() {
  jQuery('#comment, .wpcf7-textarea').on('input', function() {
    this.style.height = '5px';
    this.style.height = this.scrollHeight + 'px';
  });
}
